/* tslint:disable */
/* eslint-disable */
/**
 * Mr.Bilit Authentication api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, RequiredError } from '../base';
// @ts-ignore
import { ForgetPasswordRequest } from '../model';
// @ts-ignore
import { LoginResponse } from '../model';
// @ts-ignore
import { MigrateJwtRequest } from '../model';
// @ts-ignore
import { RefreshExpiredJwtRequest } from '../model';
// @ts-ignore
import { UserExistsResponse } from '../model';
/**
 * LoginApiApiAdminLoginGet - axios parameter creator
 * 
 * @param {string} [username] 
 * @param {string} [password] 
 * @param {string} [mobile] 
 * @param {string} [email] 
 * @param {string} [token] 
 * @param {number} [source] 
 * @param {string} [pureToken] 
 * @param {boolean} [isJwtToken] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function LoginApiApiAdminLoginGetAxiosParamCreator (username?: string, password?: string, mobile?: string, email?: string, token?: string, source?: number, pureToken?: string, isJwtToken?: boolean, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/AdminLogin`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (username !== undefined) {
        localVarQueryParameter['Username'] = username;
    }

    if (password !== undefined) {
        localVarQueryParameter['Password'] = password;
    }

    if (mobile !== undefined) {
        localVarQueryParameter['Mobile'] = mobile;
    }

    if (email !== undefined) {
        localVarQueryParameter['Email'] = email;
    }

    if (token !== undefined) {
        localVarQueryParameter['Token'] = token;
    }

    if (source !== undefined) {
        localVarQueryParameter['Source'] = source;
    }

    if (pureToken !== undefined) {
        localVarQueryParameter['PureToken'] = pureToken;
    }

    if (isJwtToken !== undefined) {
        localVarQueryParameter['IsJwtToken'] = isJwtToken;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * LoginApiApiChangePasswordPatch - axios parameter creator
 * 
 * @summary Change user password by username, oldpassword, login source, or by mobile number and login token
 * @param {string} [username] 
 * @param {string} [oldPassword] 
 * @param {string} [newPassword] 
 * @param {number} [source] 
 * @param {string} [mobile] 
 * @param {string} [token] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function LoginApiApiChangePasswordPatchAxiosParamCreator (username?: string, oldPassword?: string, newPassword?: string, source?: number, mobile?: string, token?: string, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/changePassword`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (username !== undefined) {
        localVarQueryParameter['Username'] = username;
    }

    if (oldPassword !== undefined) {
        localVarQueryParameter['OldPassword'] = oldPassword;
    }

    if (newPassword !== undefined) {
        localVarQueryParameter['NewPassword'] = newPassword;
    }

    if (source !== undefined) {
        localVarQueryParameter['Source'] = source;
    }

    if (mobile !== undefined) {
        localVarQueryParameter['Mobile'] = mobile;
    }

    if (token !== undefined) {
        localVarQueryParameter['Token'] = token;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * LoginApiApiForgotpasswordPatch - axios parameter creator
 * 
 * @param {ForgetPasswordRequest} [forgetPasswordRequest] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function LoginApiApiForgotpasswordPatchAxiosParamCreator (forgetPasswordRequest?: ForgetPasswordRequest, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/forgotpassword`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    localVarHeaderParameter['Content-Type'] = 'application/json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(forgetPasswordRequest, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * LoginApiApiLoginExistsGet - axios parameter creator
 * 
 * @param {string} [mobileOrEmail] 
 * @param {number} [source] 
 * @param {boolean} [sendTokenIfNot] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function LoginApiApiLoginExistsGetAxiosParamCreator (mobileOrEmail?: string, source?: number, sendTokenIfNot?: boolean, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/login/exists`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (mobileOrEmail !== undefined) {
        localVarQueryParameter['mobileOrEmail'] = mobileOrEmail;
    }

    if (source !== undefined) {
        localVarQueryParameter['source'] = source;
    }

    if (sendTokenIfNot !== undefined) {
        localVarQueryParameter['sendTokenIfNot'] = sendTokenIfNot;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * LoginApiApiLoginExistsV2Get - axios parameter creator
 * 
 * @param {string} [mobileOrEmail] 
 * @param {number} [source] 
 * @param {boolean} [sendTokenIfNot] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function LoginApiApiLoginExistsV2GetAxiosParamCreator (mobileOrEmail?: string, source?: number, sendTokenIfNot?: boolean, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/login/exists/v2`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (mobileOrEmail !== undefined) {
        localVarQueryParameter['mobileOrEmail'] = mobileOrEmail;
    }

    if (source !== undefined) {
        localVarQueryParameter['source'] = source;
    }

    if (sendTokenIfNot !== undefined) {
        localVarQueryParameter['sendTokenIfNot'] = sendTokenIfNot;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * LoginApiApiLoginGet - axios parameter creator
 * 
 * @summary Login params order is : 1.(Username, Password) - 2.(Email, Token) - 3.(Mobile, Token)
 * @param {string} [username] 
 * @param {string} [password] 
 * @param {string} [mobile] 
 * @param {string} [email] 
 * @param {string} [token] 
 * @param {number} [source] 
 * @param {string} [pureToken] 
 * @param {boolean} [isJwtToken] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function LoginApiApiLoginGetAxiosParamCreator (username?: string, password?: string, mobile?: string, email?: string, token?: string, source?: number, pureToken?: string, isJwtToken?: boolean, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/login`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (username !== undefined) {
        localVarQueryParameter['Username'] = username;
    }

    if (password !== undefined) {
        localVarQueryParameter['Password'] = password;
    }

    if (mobile !== undefined) {
        localVarQueryParameter['Mobile'] = mobile;
    }

    if (email !== undefined) {
        localVarQueryParameter['Email'] = email;
    }

    if (token !== undefined) {
        localVarQueryParameter['Token'] = token;
    }

    if (source !== undefined) {
        localVarQueryParameter['Source'] = source;
    }

    if (pureToken !== undefined) {
        localVarQueryParameter['PureToken'] = pureToken;
    }

    if (isJwtToken !== undefined) {
        localVarQueryParameter['IsJwtToken'] = isJwtToken;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * LoginApiApiLogoutGet - axios parameter creator
 * 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function LoginApiApiLogoutGetAxiosParamCreator (options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/logout`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * LoginApiMigrateAppTokenPost - axios parameter creator
 * 
 * @param {MigrateJwtRequest} [migrateJwtRequest] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function LoginApiMigrateAppTokenPostAxiosParamCreator (migrateJwtRequest?: MigrateJwtRequest, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/MigrateAppToken`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    localVarHeaderParameter['Content-Type'] = 'application/json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(migrateJwtRequest, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * LoginApiRefreshPost - axios parameter creator
 * 
 * @summary refresh an expired jwt token
 * @param {RefreshExpiredJwtRequest} [refreshExpiredJwtRequest] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function LoginApiRefreshPostAxiosParamCreator (refreshExpiredJwtRequest?: RefreshExpiredJwtRequest, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/refresh`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    localVarHeaderParameter['Content-Type'] = 'application/json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(refreshExpiredJwtRequest, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * LoginApiRefreshWithTokenGet - axios parameter creator
 * 
 * @summary refresh an expired jwt token with refresh token
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function LoginApiRefreshWithTokenGetAxiosParamCreator (options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/refresh-withToken`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}

/**
 * Request parameters for apiAdminLoginGet operation in LoginApi.
 * @export
 * @interface LoginApiApiAdminLoginGetRequest
 */
export interface LoginApiApiAdminLoginGetRequest {
    /**
     * 
     * @type {string}
     * @memberof LoginApiApiAdminLoginGet
     */
    readonly username?: string

    /**
     * 
     * @type {string}
     * @memberof LoginApiApiAdminLoginGet
     */
    readonly password?: string

    /**
     * 
     * @type {string}
     * @memberof LoginApiApiAdminLoginGet
     */
    readonly mobile?: string

    /**
     * 
     * @type {string}
     * @memberof LoginApiApiAdminLoginGet
     */
    readonly email?: string

    /**
     * 
     * @type {string}
     * @memberof LoginApiApiAdminLoginGet
     */
    readonly token?: string

    /**
     * 
     * @type {number}
     * @memberof LoginApiApiAdminLoginGet
     */
    readonly source?: number

    /**
     * 
     * @type {string}
     * @memberof LoginApiApiAdminLoginGet
     */
    readonly pureToken?: string

    /**
     * 
     * @type {boolean}
     * @memberof LoginApiApiAdminLoginGet
     */
    readonly isJwtToken?: boolean
}

/**
 * Request parameters for apiChangePasswordPatch operation in LoginApi.
 * @export
 * @interface LoginApiApiChangePasswordPatchRequest
 */
export interface LoginApiApiChangePasswordPatchRequest {
    /**
     * 
     * @type {string}
     * @memberof LoginApiApiChangePasswordPatch
     */
    readonly username?: string

    /**
     * 
     * @type {string}
     * @memberof LoginApiApiChangePasswordPatch
     */
    readonly oldPassword?: string

    /**
     * 
     * @type {string}
     * @memberof LoginApiApiChangePasswordPatch
     */
    readonly newPassword?: string

    /**
     * 
     * @type {number}
     * @memberof LoginApiApiChangePasswordPatch
     */
    readonly source?: number

    /**
     * 
     * @type {string}
     * @memberof LoginApiApiChangePasswordPatch
     */
    readonly mobile?: string

    /**
     * 
     * @type {string}
     * @memberof LoginApiApiChangePasswordPatch
     */
    readonly token?: string
}

/**
 * Request parameters for apiForgotpasswordPatch operation in LoginApi.
 * @export
 * @interface LoginApiApiForgotpasswordPatchRequest
 */
export interface LoginApiApiForgotpasswordPatchRequest {
    /**
     * 
     * @type {ForgetPasswordRequest}
     * @memberof LoginApiApiForgotpasswordPatch
     */
    readonly forgetPasswordRequest?: ForgetPasswordRequest
}

/**
 * Request parameters for apiLoginExistsGet operation in LoginApi.
 * @export
 * @interface LoginApiApiLoginExistsGetRequest
 */
export interface LoginApiApiLoginExistsGetRequest {
    /**
     * 
     * @type {string}
     * @memberof LoginApiApiLoginExistsGet
     */
    readonly mobileOrEmail?: string

    /**
     * 
     * @type {number}
     * @memberof LoginApiApiLoginExistsGet
     */
    readonly source?: number

    /**
     * 
     * @type {boolean}
     * @memberof LoginApiApiLoginExistsGet
     */
    readonly sendTokenIfNot?: boolean
}

/**
 * Request parameters for apiLoginExistsV2Get operation in LoginApi.
 * @export
 * @interface LoginApiApiLoginExistsV2GetRequest
 */
export interface LoginApiApiLoginExistsV2GetRequest {
    /**
     * 
     * @type {string}
     * @memberof LoginApiApiLoginExistsV2Get
     */
    readonly mobileOrEmail?: string

    /**
     * 
     * @type {number}
     * @memberof LoginApiApiLoginExistsV2Get
     */
    readonly source?: number

    /**
     * 
     * @type {boolean}
     * @memberof LoginApiApiLoginExistsV2Get
     */
    readonly sendTokenIfNot?: boolean
}

/**
 * Request parameters for apiLoginGet operation in LoginApi.
 * @export
 * @interface LoginApiApiLoginGetRequest
 */
export interface LoginApiApiLoginGetRequest {
    /**
     * 
     * @type {string}
     * @memberof LoginApiApiLoginGet
     */
    readonly username?: string

    /**
     * 
     * @type {string}
     * @memberof LoginApiApiLoginGet
     */
    readonly password?: string

    /**
     * 
     * @type {string}
     * @memberof LoginApiApiLoginGet
     */
    readonly mobile?: string

    /**
     * 
     * @type {string}
     * @memberof LoginApiApiLoginGet
     */
    readonly email?: string

    /**
     * 
     * @type {string}
     * @memberof LoginApiApiLoginGet
     */
    readonly token?: string

    /**
     * 
     * @type {number}
     * @memberof LoginApiApiLoginGet
     */
    readonly source?: number

    /**
     * 
     * @type {string}
     * @memberof LoginApiApiLoginGet
     */
    readonly pureToken?: string

    /**
     * 
     * @type {boolean}
     * @memberof LoginApiApiLoginGet
     */
    readonly isJwtToken?: boolean
}

/**
 * Request parameters for migrateAppTokenPost operation in LoginApi.
 * @export
 * @interface LoginApiMigrateAppTokenPostRequest
 */
export interface LoginApiMigrateAppTokenPostRequest {
    /**
     * 
     * @type {MigrateJwtRequest}
     * @memberof LoginApiMigrateAppTokenPost
     */
    readonly migrateJwtRequest?: MigrateJwtRequest
}

/**
 * Request parameters for refreshPost operation in LoginApi.
 * @export
 * @interface LoginApiRefreshPostRequest
 */
export interface LoginApiRefreshPostRequest {
    /**
     * 
     * @type {RefreshExpiredJwtRequest}
     * @memberof LoginApiRefreshPost
     */
    readonly refreshExpiredJwtRequest?: RefreshExpiredJwtRequest
}

/**
* 
* @param {LoginApiApiAdminLoginGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function LoginApiApiAdminLoginGet(requestParameters: LoginApiApiAdminLoginGetRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await LoginApiApiAdminLoginGetAxiosParamCreator(requestParameters.username, requestParameters.password, requestParameters.mobile, requestParameters.email, requestParameters.token, requestParameters.source, requestParameters.pureToken, requestParameters.isJwtToken, options, configuration);
    const request: () => AxiosPromise<LoginResponse> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary Change user password by username, oldpassword, login source, or by mobile number and login token
* @param {LoginApiApiChangePasswordPatchRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function LoginApiApiChangePasswordPatch(requestParameters: LoginApiApiChangePasswordPatchRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await LoginApiApiChangePasswordPatchAxiosParamCreator(requestParameters.username, requestParameters.oldPassword, requestParameters.newPassword, requestParameters.source, requestParameters.mobile, requestParameters.token, options, configuration);
    const request: () => AxiosPromise<boolean> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {LoginApiApiForgotpasswordPatchRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function LoginApiApiForgotpasswordPatch(requestParameters: LoginApiApiForgotpasswordPatchRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await LoginApiApiForgotpasswordPatchAxiosParamCreator(requestParameters.forgetPasswordRequest, options, configuration);
    const request: () => AxiosPromise<boolean> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {LoginApiApiLoginExistsGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function LoginApiApiLoginExistsGet(requestParameters: LoginApiApiLoginExistsGetRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await LoginApiApiLoginExistsGetAxiosParamCreator(requestParameters.mobileOrEmail, requestParameters.source, requestParameters.sendTokenIfNot, options, configuration);
    const request: () => AxiosPromise<boolean> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {LoginApiApiLoginExistsV2GetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function LoginApiApiLoginExistsV2Get(requestParameters: LoginApiApiLoginExistsV2GetRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await LoginApiApiLoginExistsV2GetAxiosParamCreator(requestParameters.mobileOrEmail, requestParameters.source, requestParameters.sendTokenIfNot, options, configuration);
    const request: () => AxiosPromise<UserExistsResponse> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary Login params order is : 1.(Username, Password) - 2.(Email, Token) - 3.(Mobile, Token)
* @param {LoginApiApiLoginGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function LoginApiApiLoginGet(requestParameters: LoginApiApiLoginGetRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await LoginApiApiLoginGetAxiosParamCreator(requestParameters.username, requestParameters.password, requestParameters.mobile, requestParameters.email, requestParameters.token, requestParameters.source, requestParameters.pureToken, requestParameters.isJwtToken, options, configuration);
    const request: () => AxiosPromise<LoginResponse> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function LoginApiApiLogoutGet(options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await LoginApiApiLogoutGetAxiosParamCreator(options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {LoginApiMigrateAppTokenPostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function LoginApiMigrateAppTokenPost(requestParameters: LoginApiMigrateAppTokenPostRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await LoginApiMigrateAppTokenPostAxiosParamCreator(requestParameters.migrateJwtRequest, options, configuration);
    const request: () => AxiosPromise<LoginResponse> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary refresh an expired jwt token
* @param {LoginApiRefreshPostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function LoginApiRefreshPost(requestParameters: LoginApiRefreshPostRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await LoginApiRefreshPostAxiosParamCreator(requestParameters.refreshExpiredJwtRequest, options, configuration);
    const request: () => AxiosPromise<LoginResponse> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary refresh an expired jwt token with refresh token
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function LoginApiRefreshWithTokenGet(options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await LoginApiRefreshWithTokenGetAxiosParamCreator(options, configuration);
    const request: () => AxiosPromise<LoginResponse> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
